import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { SHARED_NAMESPACE } from '../actions';

import PaymentScheduleLinkComponent from '../components/payment-schedule-link';
import Purchase from '../lib/purchase';

class PaymentScheduleLink extends Component {
  get payments() { return this.props.payments; }

  render() {
    if (this.props.onlyPayments) {
      return (
        <PaymentScheduleLinkComponent
          payments={this.props.payments}
          totalAmount={this.props.totalAmount}
          asIcon={this.props.asIcon}
        />
      );
    }

    return (
      <PaymentScheduleLinkComponent {...this.props} />
    );
  }
}

const mapStateToProps = ({ purchases, projections }, ownProps) => {
  const purchase = purchases.byId[purchases.current];
  const namespace = ownProps.namespace || SHARED_NAMESPACE;
  const projected = get(projections, `${namespace}.purchase`);
  const { costComponents, product: { costType }, currentTotalCostAmount, currentProductCostAmount } = purchase;
  const totalAmount = Purchase.isPerSlot(costType) ? currentProductCostAmount : currentTotalCostAmount;

  return {
    purchase,
    costComponents,
    costs: purchase.product.costs,
    costType,
    payments: projected ? projected.payments : [],
    totalAmount: totalAmount,
    asIcon: false
  };
};

export default connect(mapStateToProps)(PaymentScheduleLink);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-payments-schedule-link.container.js